import { RouterProvider } from 'react-router';
import { AuthProvider } from './lib/auth';
import { createRouter } from './router';

const router = createRouter();

export function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  );
}
